import React__default from 'react';
import { Icon } from '@sravni/react-design-system/lib/Icon';
import { Link } from '@sravni/react-design-system/lib/Typography';
import { useTheme, useStyles } from '@sravni/react-utils';
import { customIconParam } from '../../../consts/links.js';
import { decorateRelativeUrlByDomain, makeRelAttribute } from '../../../utils/links.js';
import { getCustomStyles, getCustomIconStyles } from '../../../utils/styles.js';
import '../../Providers/CustomPropsProvider/src/CustomPropsProvider.js';
import { useCustomProps } from '../../Providers/CustomPropsProvider/hooks/useCustomProps.js';
import modules_51430e0a from '../styles/MenuItem.module.less.js';

const MenuItem = React__default.forwardRef((props, ref) => {
    const { item, size = 14, ...restProps } = props;
    const { text, href, openInNew, icon } = item;
    const { domains } = useCustomProps();
    const [theme] = useTheme();
    const cx = useStyles(modules_51430e0a);
    if (!href) {
        return null;
    }
    const isCustomIcon = href.includes(customIconParam);
    return (React__default.createElement(Link, { ref: ref, "data-label": text, color: "black", href: domains?.base ? decorateRelativeUrlByDomain(href, domains.base) : href, style: getCustomStyles(item), target: openInNew ? '_blank' : undefined, rel: makeRelAttribute(item), className: cx('item'), ...restProps },
        icon ? (React__default.createElement(Icon, { size: 16, color: "gray", className: cx('imgWrapper'), style: getCustomIconStyles(item) },
            React__default.createElement("img", { src: icon, alt: "", className: cx('img', { dark: theme === 'guinness' && !isCustomIcon }) }))) : null,
        text));
});
MenuItem.displayName = 'MenuItem';

export { MenuItem };
//# sourceMappingURL=MenuItem.js.map
